import { render, staticRenderFns } from "./bings.vue?vue&type=template&id=d1bd73d4"
import script from "./bings.vue?vue&type=script&lang=js"
export * from "./bings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports